__webpack_require__.p = "https://k-cf-release.alpha.groovehq.com/app-release/";